const getters = {
  // 框架相关
  sidebar: state => state.app.sidebar, // 是否隐藏左侧菜单
  uiConfig: state => state.app.uiConfig, // 配置项配置
  system_source: state => state.app.system_source, // url上源系统编码
  appLoading: state => state.app.loading, // 是否显示全局loading
  sendSmsTypes: state => state.app.sendSmsTypes, // 发送短信类型
  thirdPartyQrcode: state => state.app.thirdPartyQrcode, // 第三方登录二维码
  // sysCodeWhiteList: state => state.app.sysCodeWhiteList, // 融合登录开关白名单
  // 公共
  mobileCountries: state => state.public.mobileCountries, // 全量国家区号列表
  countries: state => state.public.countries, // 全量国家列表
  // 站点相关
  site: state => state.site, // 站点信息
  siteCode: state => state.site.siteCode, // 站点编码
  siteConfig: state => state.site.siteConfig, // 站点配置
  siteList: state => state.site.siteList, //  站点列表
  language: state => state.site.language, //  站点默认语言
  langName: state => state.site.langName, //  站点默认语言名
  // cookie政策相关
  cookie_terms: state => state.app.cookie_terms,
  cookie_agree: state => state.app.cookie_agree,
  // 账户信息
  accountInfo: state => state.user.accountInfo, //  账户信息
  device: state => state.app.device, // 设备类型（desktop，mobile），默认是电脑桌面
  token: state => state.user.token, // token
  roles: state => state.user.roles, // 权限
  permission_routes: state => state.permission.routes, // 动态路由左侧菜单栏
  userInfo: state => state.user.userInfo, // 账户信息
  isAgreeFirst: state => state.user.isAgreeFirst, // 同意协议标识
  isAgreeSecond: state => state.user.isAgreeSecond, // 同意协议标识
  isRepeat: state => state.user.isRepeat, // 同意协议标识
  commonUrlParams: state => state.app.commonUrlParams, // 需要放在登录、注册等接口中的公共参数
  isVerficationCodeFirst: state => state.app.isVerficationCodeFirst, // ready 未拉到状态，on 开启验证码登录优先模式 off 关闭验证码登录优先模式
  defaultCookieId: state => state.app.defaultCookieId,
  regexpRemote: state => state.site.regexpRemote, // 远程正则
  showMessageNotice: state => state.site.showMessageNotice,
  messageNoticeData: state => state.site.messageNoticeData,
  enableGeneratedPasswordCountry: state => state.site.enableGeneratedPasswordCountry,
  twoFactorAuth: state => state.user.twoFactorAuth,
  twoFactorAuthLoading: state => state.user.twoFactorAuthLoading,
  // showSmsDialog: state => state.app.twoFactorAuth.showDialog,
  siteConfigDone: state => state.site.siteConfigDone, // 站点配置是否加载完成
  preloadingForm: state => state.user.preloadingForm, // 预加载表单数据
}
export default getters
